import { render } from "./TopBar.vue.js?vue&type=template&id=c4268b5e!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./TopBar.vue?vue&type=template&id=c4268b5e"
import script from "./TopBar.vue.js?vue&type=script&lang=js!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./TopBar.vue?vue&type=script&lang=js"
export * from "./TopBar.vue.js?vue&type=script&lang=js!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./TopBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__